// extracted by mini-css-extract-plugin
export default {"form":"AllocationModal_form__LAsVa"};